import { Component } from '@angular/core';
import { FooterComponent } from "../../../partials/footer/footer.component";
import { NavbarComponent } from "../../../partials/navbar/navbar.component";
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-xlab',
  standalone: true,
  imports: [FooterComponent, NavbarComponent],
  templateUrl: './xlab.component.html',
  styleUrl: './xlab.component.css'
})
export class XlabComponent {
  currentImage: string = 'src/assets/img/xlab_page/656dc59650ae0ebf14803387_XLAB-30°-p-1080.png';

  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().xlab_page;
    this.title.setTitle('PRINX - Xlab Confort EV');
    
    if (typeof document !== 'undefined') {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', `${this.texts.hero.description}`);
      }
    }

  }

  imageSource(source: string): void {
    this.currentImage = source;
  }

  openUrlInNewTab(url: string): void {
    window.open(url, '_blank');
  }
}
